import React, { useMemo, useRef, useState } from 'react'

import {
  FuncoesDataHora,
  IconeCalendarioPequeno,
  IconeComentario,
  IconeRelogioPequeno,
  IconeRespostaComentario,
  IconeBaixar,
  IconeCadeado,
  Tooltip,
  IconeResponder,
  FormUnform,
  Botao,
  ComentarioTopicoArquivoInput,
  FormRef,
  IconeDoAvatarDoUsuario,
  AutenticacaoContainer,
  Visao
} from 'src/componentes'
import { CHAVE_AVATAR_ALUNO } from 'src/componentes/barra-superior-layout/providers/barra-superior.provider'
import { EditorUnform } from 'src/componentes/unform/editor'
import { sanitizeUtil } from 'src/componentes/utils'
import { Api } from 'src/servicos'
import * as Storage from 'src/servicos/local-storage'
import { Comentario as ComentarioType } from 'src/tipos'

import { ContainerBotao } from '../styles'
import { schema } from './schema'
import {
  Container,
  Conteudo,
  ContainarStatus,
  TextoComentario,
  ContainerChildren,
  ContainerDownloadArquivo,
  TituloComentario,
  TextoResponder,
  ContainerResponder,
  Linha,
  ImagemUsuario
} from './styles'
import { ComentarioProps } from './tipos'
const avatar = Storage.obter(CHAVE_AVATAR_ALUNO) as { foto: string }

export const ComentarioTopicoTCC: React.FC<ComentarioProps> = ({
  comentarios,
  topico,
  grupo,
  orientacao,
  carregarTopico
}) => {
  const [respondendo, definirRespondendo] = useState<string>(null)
  const [carregando, definirCarregando] = useState(false)
  const formRef = useRef<FormRef>()
  const { usuario, visao } = AutenticacaoContainer.useContainer()

  const visaoResposta = useMemo(
    () =>
      visao === Visao.IPGS ||
      visao === Visao.Professor ||
      visao === Visao.Parceiro,
    [visao]
  )

  const aoClicarResponder = (comentario: string) => {
    formRef?.current?.clearField('comentario')
    definirRespondendo(comentario)
  }

  const adicionarResposta = async (dados: {
    comentario: string
    privado: boolean
    arquivo?: File | string
  }) => {
    try {
      definirCarregando(true)

      await Api.CriarRespostaComentario(
        grupo,
        topico,
        respondendo,
        sanitizeUtil(dados.comentario),
        dados.privado ?? false,
        dados.arquivo
      )

      formRef.current?.clearField('comentario')
      formRef.current?.clearField('arquivo')
      await carregarTopico()
    } finally {
      definirCarregando(false)
    }
  }

  const renderizarResponder = (comentario: ComentarioType) => {
    return respondendo === comentario?.comentarioId ? (
      <ContainerResponder>
        <FormUnform
          ref={formRef}
          acaoSucesso={adicionarResposta}
          schema={schema}
        >
          <Conteudo>
            <Linha>
              <ImagemUsuario>
                {avatar && avatar.foto ? (
                  <img src={avatar.foto} />
                ) : (
                  IconeDoAvatarDoUsuario
                )}
              </ImagemUsuario>
              <EditorUnform
                id="comentario"
                name="comentario"
                label="Adicionar um comentário"
              />
            </Linha>
          </Conteudo>
          <ContainerBotao>
            <ComentarioTopicoArquivoInput id="arquivo" name="arquivo" />
            <Botao
              texto={'Enviar Comentário'}
              carregando={carregando}
              type="button"
              onClick={() => formRef?.current?.submitForm()}
            />
          </ContainerBotao>
        </FormUnform>
      </ContainerResponder>
    ) : (
      <ContainerResponder
        onClick={() => aoClicarResponder(comentario.comentarioId)}
      >
        {IconeResponder}
        <TextoResponder> Responder </TextoResponder>
      </ContainerResponder>
    )
  }
  const renderizarComentario = (
    tipo: 'comentario' | 'resposta',
    comentario: ComentarioType,
    comentarioOrigemId?: string,
    children?: JSX.Element
  ) => {
    return (
      <div key={comentario.comentarioId}>
        {tipo === 'comentario' ? IconeComentario : IconeRespostaComentario}
        <Conteudo>
          <TituloComentario>
            {comentario?.nomeUsuario}{' '}
            {comentario?.privado ? (
              <>
                <div
                  data-tip="Somente o criador do tópico/comentário e você poderão ver esse comentário"
                  data-for={`${comentario?.comentarioId}-tooltip-cadeado-comentario`}
                >
                  {IconeCadeado}
                </div>
                <Tooltip
                  id={`${comentario?.comentarioId}-tooltip-cadeado-comentario`}
                  place="right"
                  offset={{ top: 5 }}
                />
              </>
            ) : (
              <></>
            )}
          </TituloComentario>
          <ContainarStatus>
            <span>{tipo === 'comentario' ? 'Postado' : 'Respondido'} em</span>
            {IconeCalendarioPequeno}
            <span>{FuncoesDataHora.novaData(comentario?.dataInclusao)}</span>
            {IconeRelogioPequeno}
            <span>
              {FuncoesDataHora.horaFormatada24H(
                new Date(comentario?.dataInclusao)
              )}
            </span>
          </ContainarStatus>
          <TextoComentario>
            {' '}
            <p
              dangerouslySetInnerHTML={{
                __html: sanitizeUtil(
                  comentario?.texto?.replaceAll('<p></p>', '<br />')
                )
              }}
            />
          </TextoComentario>
          {comentario.possuiArquivo && (
            <ContainerDownloadArquivo>
              {' '}
              <button
                type="button"
                data-tip="Baixar"
                data-for={`${comentario.comentarioId}-tooltip-editar`}
                onClick={async e => {
                  e.stopPropagation()
                  if (tipo === 'comentario') {
                    await Api.DownloadArquivoComentario(
                      topico,
                      comentario.comentarioId
                    )
                  } else {
                    await Api.DownloadArquivoComentarioResposta(
                      topico,
                      comentarioOrigemId,
                      comentario.comentarioId
                    )
                  }
                }}
              >
                {IconeBaixar}
              </button>
            </ContainerDownloadArquivo>
          )}
          {children}
          {tipo === 'comentario' &&
            (comentario.usuarioId === usuario.id || visaoResposta) &&
            orientacao &&
            renderizarResponder(comentario)}
        </Conteudo>
      </div>
    )
  }

  return (
    <Container>
      {comentarios?.map(comentario =>
        renderizarComentario(
          'comentario',
          comentario,
          null,
          <ContainerChildren>
            {comentario.respostasComentario.map(resposta =>
              renderizarComentario(
                'resposta',
                resposta,
                comentario.comentarioId
              )
            )}
          </ContainerChildren>
        )
      )}
    </Container>
  )
}
